import { Directive, TemplateRef, inject, input } from '@angular/core';

import type { EsnTableColumn } from '../../../shared/types/data';

/**
 * What a cell template receives: the row, the cell's raw value, its column and the row index.
 */
export interface EsnTableCellContext<T = unknown> {
  $implicit: T;
  value: unknown;
  column: EsnTableColumn;
  index: number;
}

/**
 * Custom rendering for one column's cells: `<ng-template esnCell="status" let-row>…</ng-template>`.
 * Columns without one show their raw value as text.
 */
@Directive({ selector: 'ng-template[esnCell]' })
// Rows are untyped in templates (`let-row` is `any`), as the directive cannot see the table's row type.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class TableCellDirective<T = any> {
  /**
   * The column key this template renders.
   */
  readonly key = input.required<string>({ alias: 'esnCell' });

  readonly template = inject<TemplateRef<EsnTableCellContext<T>>>(TemplateRef);

  static ngTemplateContextGuard<T>(_dir: TableCellDirective<T>, ctx: unknown): ctx is EsnTableCellContext<T> {
    return true;
  }
}
